import InstagramWidget from './InstagramWidget'

export default InstagramWidget
